const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
// The palette every team gets when nobody chose its colours.
const DEFAULT_PAIR = ["#c9daf8", "#fff2cc"];

const isHex = (value) => typeof value === "string" && HEX.test(value);

/**
 * The colours of the player card from the team's colours.
 * A malformed value or the untouched default palette counts as no colour: the primary falls back to
 * `fallback.primary`, and the secondary falls back to the primary.
 * `onSecondary` is the text colour for the secondary: the team's own text colour for whichever colour the secondary ended up as.
 */
export function playerCardColors(teamColors, fallback) {
	const pair = [teamColors?.primary, teamColors?.secondary].map((c) => String(c).toLowerCase());
	const usesDefaults = pair[0] === DEFAULT_PAIR[0] && pair[1] === DEFAULT_PAIR[1];
	const [primaryText, secondaryText] = (teamColors?.font_colors ?? []).map((c) => (isHex(c) ? c : null));
	const ownPrimary = !usesDefaults && isHex(teamColors?.primary);
	const ownSecondary = !usesDefaults && isHex(teamColors?.secondary);
	const primary = ownPrimary ? teamColors.primary : fallback.primary;
	const onPrimary = (ownPrimary && primaryText) || fallback.onPrimary;
	return {
		primary,
		secondary: ownSecondary ? teamColors.secondary : primary,
		onSecondary: ownSecondary ? secondaryText || fallback.onPrimary : onPrimary,
	};
}
